import i18n from "../i18n";
import settings from "settings";
import get from "lodash/get";

export const t = i18n.getFixedT();

export const x = string => string;

export const getLocalizationSafe = (object, string) => {
  return get(object, ['localization', string, settings.realm.languageCodeGloss], '');
};